import { Grid, Tab, Tabs, styled } from "@mui/material";

import { useFormContext } from "react-hook-form";

function MobileDepositNetworks({ selectedCoinNetworks }) {
  const { watch, setValue } = useFormContext();
  const network = watch("network");

  const handleChange = (_, val) => {
    setValue("network", val);
  };

  return (
    <Grid item xs={12}>
      <TabsStyle value={network} onChange={handleChange}>
        {selectedCoinNetworks?.map((item, index) => (
          <Tab key={index} value={item?.networkId} label={item?.networkName} />
        ))}
      </TabsStyle>
    </Grid>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  marginTop: theme.spacing(3),

  ".MuiTabs-flexContainer": {
    justifyContent: "space-around",
  },
}));

export default MobileDepositNetworks;
